import { appUrls } from "helpers/Urls";
import axiosInstance from "utils/axiosInstance";

const getShareToken = async ({patientId}) => {
  const { data } = await axiosInstance.post(appUrls.GetShareToken(patientId));
  return data;
};

const sendReportLinkWithSms = async ({ id, phoneNumber }) => {
  const res = await axiosInstance.post(appUrls.sendSmsShareLink(id, phoneNumber));
  return res;
};

export { getShareToken, sendReportLinkWithSms };